module.exports = __webpack_public_path__ + "img/logo_w_black.b3a7b834.svg";